import { string } from "yup";

export const CRM_CONTACT_ID_URL_PLACEHOLDER = "{crm_contact_id}";

const CRM_CONTACT_ID_VALIDATION_VALUE = "crm-contact-id";

export function replaceCrmContactIdUrlPlaceholderForValidation(
  value: string,
): string {
  return value.replaceAll(
    CRM_CONTACT_ID_URL_PLACEHOLDER,
    CRM_CONTACT_ID_VALIDATION_VALUE,
  );
}

export function isValidDocumentSpaceConfigLinkUrl(value: string): boolean {
  return string()
    .url()
    .required()
    .isValidSync(replaceCrmContactIdUrlPlaceholderForValidation(value));
}
